<template>
  <ViewTransition>
    <div id="gtm-home" class="Home">
      <BackgroundVideo
        v-if="isDesktop"
        :videoUrl="videos.webm"
        :poster="img.poster"
        :muted="true"
        :fixed="true"
        :loop="true"
        :playsinline="true"
        :autoplay="true"
        :width="1920"
        :height="1080"
      />

      <BackgroundVideo
        v-if="isMobile"
        :videoUrl="videos.video"
        :poster="img.poster"
        :muted="true"
        :fixed="true"
        :loop="true"
        :playsinline="true"
        :autoplay="true"
        :width="1920"
        :height="1080"
      />

      <!-- <img class="Home-logo" :src="img.logo" alt="Carta Blanca Logo" />
      <h4>{{ model.year }}</h4> -->
      <!-- <h1>{{ model.title }}</h1> -->
      <!-- <p>{{ model.excess }}</p> -->
    </div>
    <ModalAH
      v-if="showModal"
      wichModal="alcoholandhealth"
      @close="showModal = false"
    />
  </ViewTransition>
</template>

<script>
import model from "@/data/home.json";
import ViewTransition from "@/transitions/ViewTransition.vue";
import BackgroundVideo from "@/components/BackgroundVideo";
import ModalAH from "@/components/ModalAH";
import TagFunctions from "@/assets/tagFunctions.js";

const utm = {
  utm_source: "Lata-CartaBlanca",
  utm_content: "QR_AvisoAlcohol",
  utm_medium: "PopUp",
};

export default {
  name: "Home",
  props: {
    wichModal: {
      type: String,
      default: "none",
    },
  },
  data: () => ({
    model,
    showModal: false,
    videos: {
      webm: require("@/assets/videos/homeNew_web.mp4"),
      video: require("@/assets/videos/homeNew_video.mp4"),
    },
    img: {
      poster: require("@/assets/img/home/home_poster.jpg"),
      logo: require("@/assets/img/logo.svg"),
    },
    isMobile: false,
    videoSource: require("@/assets/videos/homeNew_web.mp4"),
    isDesktop: false,
  }),
  computed: {
    // videoSource: function () {
    //   console.log("xxxxx");
    //   return this.isMobile ? this.videos.video : this.videos.webm;
    // },
    // videoResolution: function () {
    //   // return window.addEventListener("resize", capturarCambioResolucion);
    //   console.log("Resolución de pantalla cambiada");
    //   console.log(
    //     "Nueva resolución: " + window.innerWidth + "x" + window.innerHeight,
    //   );
    // },
  },
  mounted() {
    TagFunctions.evPagePush("Home");

    var query = localStorage.getItem("query");

    if (query == null) {
      query = location.search;
    }

    const params = new URLSearchParams(query);

    query = query.replace("redirect=/&", "").replace("redirect=/", "");

    let url = query;

    history.pushState(null, "", location.href + url);

    if (
      utm["utm_source"] === params.get("utm_source") &&
      utm["utm_content"] === params.get("utm_content") &&
      utm["utm_medium"] === params.get("utm_medium")
    ) {
      setTimeout(() => {
        this.showModal = true;
      }, 3000);
    }
  },
  components: { ViewTransition, BackgroundVideo, ModalAH },
  created() {
    this.updateVideoSource();
    window.addEventListener("resize", () => {
      this.updateVideoSource();
    });
  },
  // beforeDestroy() {
  //   console.log("beforeDestroy");
  //   window.removeEventListener("resize", this.updateVideoSource);
  // },
  methods: {
    updateVideoSource() {
      this.isMobile = false;
      this.isDesktop =false;
      setTimeout(() => {
        if (window.innerWidth > 768) {
          this.isDesktop = true;
          this.isMobile = false;
        } else {
          this.isDesktop = false;
          this.isMobile = true;
        }
      },500);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './Home.styl';
</style>
